export default (post_id) => ({
    isFavorite: undefined,
    loading: false,
    post_id: null,

    init() {
        this.post_id = Number(post_id)

        document.addEventListener('favorites-store-change', () => {
            this.getFavoriteStatus()
        })
    },

    getFavoriteStatus() {
        this.isFavorite = this.$store.favorites.isFavorite(this.post_id)
    },

    async handleClick() {
        if (this.$store.auth.isLoggedIn) {
            this.loading = true
            await this.$store.favorites.toggle(this.post_id, '')
            this.loading = false
        }
    },
})
